import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

const transformData = [
    {
        name: 'Established entrepreneur, running a business for more than 2 years',
        color: '#5b9bd5',
        value: 'BIZ>2Y_T0',
    },
    {
        name: 'Start-upper, running a business for less than 2 years',
        color: '#ed7d32',
        value: 'BIZ<2Y_T0',
    },
    {
        name: 'Employed, in any role including managerial and executive, with a business idea',
        color: '#a5a5a5',
        value: 'BIZ_IDEA_EM_T0',
    },
    {
        name: 'Unemployed with a business idea',
        color: '#fec000',
        value: 'BIZ_IDEA_UNEM_T0',
    },
];

/**
 * question: "Please tell us what your starting point is:
 * == baseline
 * career_status_t0
 * 
 * @param props 
 * @returns 
 */
export const careerProfileChartCalculation = (props: any) => {

    return getDefaultPieFormatting(
        'Career Profile',
        transformData.map(({name, color, value}) => ({
            name,
            color,
            y: props.baselineSubmissions.filter((submission: any) => submission.career_status_t0 === value).length
        }))
    );
}